// --- GLOBAL PATCHES: Kein Auto-Open & kein Redirect zur Cart-Seite ---

// A) Jegliches "cart:open" beim Add-to-Cart blockieren (Capture!)
document.addEventListener('cart:open', function (evt) {
  if (evt?.detail?.reason === 'add-to-cart') {
    evt.stopImmediatePropagation();
  }
}, true);

// Manche Themes feuern "product:added" und öffnen dann den Drawer
document.addEventListener('product:added', function (evt) {
  evt.stopImmediatePropagation();
}, true);

// B) Drawer.show() nur mit expliziter Erlaubnis
(function () {
  function patchDrawer() {
    const el = document.querySelector('[data-js-site-cart-sidebar]');
    if (!el || el.__drawerShowPatched) return;
    const original = typeof el.show === 'function' ? el.show.bind(el) : null;
    if (!original) return;
    el.show = function (...args) {
      if (window.ALLOW_CART_OPEN === true) {
        window.ALLOW_CART_OPEN = false;
        return original(...args);
      }
      return; // keine Auto-Opens
    };
    el.__drawerShowPatched = true;
  }
  document.addEventListener('DOMContentLoaded', patchDrawer);
  document.addEventListener('shopify:section:load', patchDrawer);
})();

// C) Redirects zur /cart Seite kurzzeitig unterbinden (während Add-to-Cart)
(function () {
  const loc = window.location;
  const origAssign = loc.assign.bind(loc);
  const origReplace = loc.replace.bind(loc);

  function isCartUrl(u) {
    try { const url = typeof u === 'string' ? new URL(u, loc.href) : u; return /\/cart($|[\?\/#])/.test(url.pathname); }
    catch { return false; }
  }

  function guard(fn) {
    return function (u) {
      if (window.__BLOCK_CART_REDIRECT === true && isCartUrl(u)) {
        return;
      }
      return fn(u);
    }
  }

  if (!window.__HC_LOC_PATCHED__) {
    loc.assign = guard(origAssign);
    loc.replace = guard(origReplace);
    window.__HC_LOC_PATCHED__ = true;
  }
})();

// D) AJAX Add-to-Cart + Button-Feedback (✓ Hinzugefügt)
(function () {
  function showAddedFeedback(form) {
    const btn =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent || btn.value || '';
    }

    const setBtnText = (t) => ('value' in btn ? (btn.value = t) : (btn.textContent = t));

    btn.classList.remove('is-loading', 'is-error');
    btn.classList.add('is-added');
    btn.setAttribute('aria-live', 'polite');
    setBtnText('✓ Hinzugefügt');

    clearTimeout(btn.__addedTimer);
    btn.__addedTimer = setTimeout(() => {
      btn.classList.remove('is-added');
      setBtnText(btn.dataset.originalText || '');
    }, 1200);

    const a11y = document.getElementById('a11y-status');
    if (a11y) a11y.textContent = 'Produkt in den Warenkorb gelegt.';
  }

  function setLoading(form, isLoading) {
    const btn =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');
    if (!btn) return;
    btn.classList.toggle('is-loading', !!isLoading);
    btn.disabled = !!isLoading;
  }

  function bindAjaxAdd(form) {
    if (!form || form.__hcBound) return;
    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?/i.test(action)) return;

    form.__hcBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const fd = new FormData(form);
      setLoading(form, true);

      // Redirects blocken, die ggf. von anderen Skripten kommen
      window.__BLOCK_CART_REDIRECT = true;
      setTimeout(() => { window.__BLOCK_CART_REDIRECT = false; }, 3000);

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' },
      })
        .then((r) => (r.ok ? r.json() : r.text().then((t) => Promise.reject(t))))
        .then(() => {
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          } else {
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                document.querySelectorAll('[data-header-cart-count]').forEach((el) => (el.textContent = cart.item_count));
              });
          }
          showAddedFeedback(form);
        })
        .catch((err) => {
          console.warn('Add-to-cart error:', err);
          form.querySelector('button, input[type="submit"]')?.classList.add('is-error');
        })
        .finally(() => setLoading(form, false));
    }, { passive: false });
  }

  function scan() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(bindAjaxAdd);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', (e) => {
    (e.target || document).querySelectorAll?.('form[action*="/cart/add"]').forEach(bindAjaxAdd);
  });
})();

// --- Header-Cart-Icon wieder aktivieren (bewusstes Öffnen des Drawers) ---
(function () {
  // Wähle möglichst viele gängige Selektoren im Local Theme ab
  const SELECTORS = [
    '[data-js-open-cart]',
    '[data-header-cart]',
    '[data-header-cart-toggle]',
    '.header-cart',
    '.site-header__cart',
    'a[href="/cart"]' // Link, der sonst zur /cart-Seite führen würde
  ];

  function getCartTriggers(root=document) {
    // Dedup der gefundenen Elemente
    const seen = new Set();
    const nodes = [];
    SELECTORS.forEach(sel => {
      root.querySelectorAll(sel).forEach(el => {
        if (!seen.has(el)) { seen.add(el); nodes.push(el); }
      });
    });
    return nodes;
  }

  function openCartDrawer() {
    const drawer = document.querySelector('[data-js-site-cart-sidebar]');
    if (drawer && typeof drawer.show === 'function') {
      // Unser globaler Patch erlaubt nur mit Flag:
      window.ALLOW_CART_OPEN = true;
      drawer.show();
      return true;
    }
    return false;
  }

  function bindCartIcon(el) {
    if (!el || el.__hcCartBound) return;
    el.__hcCartBound = true;

    el.addEventListener('click', function (e) {
      // Nur Linksklick/Enter; Mittelklick/Strg-Klick soll weiterhin einen neuen Tab öffnen dürfen
      const isPlainLeftClick = (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey);
      if (!isPlainLeftClick && el.tagName === 'A') return;

      // Versuch Drawer zu öffnen
      const opened = openCartDrawer();
      if (opened) {
        // Wenn wir erfolgreich geöffnet haben, verhindern wir einen etwaigen Link-Redirect
        e.preventDefault();
      } else {
        // Fallback: zur /cart Seite gehen (falls kein Drawer existiert)
        // Nichts tun, Browser folgt ggf. dem href="/cart"
      }
    });
  }

  function initCartTriggers(scope=document) {
    getCartTriggers(scope).forEach(bindCartIcon);
  }

  document.addEventListener('DOMContentLoaded', () => initCartTriggers(document));
  // Falls der Header dynamisch neu gerendert wird
  document.addEventListener('shopify:section:load', (e) => initCartTriggers(e.target || document));
})();
// --- Globaler Fallback: Klicks auf Links zu /cart abfangen und Drawer öffnen ---
document.addEventListener('click', function (e) {
  // suche den nächsten Link zu /cart (auch wenn auf SVG/Span geklickt wurde)
  const link = e.target.closest && e.target.closest('a[href="/cart"]');
  if (!link) return;

  // nur "normaler" Linksklick (Cmd/Strg/Shift/Alt sollen neuen Tab etc. erlauben)
  const plainLeftClick = (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey);
  if (!plainLeftClick) return;

  const drawer = document.querySelector('[data-js-site-cart-sidebar]');
  if (drawer && typeof drawer.show === 'function') {
    window.ALLOW_CART_OPEN = true;
    drawer.show();
    e.preventDefault(); // Redirect zur /cart verhindern
  }
}, true); // <— capture!

// === Header-Cart zuverlässig im aktuellen Tab öffnen ===
(function () {
  // Prüft, ob Klick aus dem Cart-Icon/Link/Btn stammt
  function getCartTrigger(start) {
    if (!start || !start.closest) return null;
    return start.closest(
      // deckt gängige Varianten im Local-Theme ab
      'a[href="/cart"], a[href*="/cart?"], ' +           // Link zur Cart
      '[data-js-open-cart], [data-header-cart], ' +      // Custom/Theme Hooks
      '[data-header-cart-toggle], .header-cart, ' +
      '.site-header__cart, [aria-controls="CartDrawer"]'
    );
  }

  // Drawer öffnen (mit unserem Opt-In-Flag)
  function openDrawerIfAvailable() {
    const drawer = document.querySelector('[data-js-site-cart-sidebar], #CartDrawer, modal-box#CartDrawer');
    if (drawer && typeof drawer.show === 'function') {
      window.ALLOW_CART_OPEN = true;
      drawer.show();
      return true;
    }
    return false;
  }

  // KLICKS abfangen (capture), IMMER im selben Tab
  document.addEventListener('click', function (e) {
    const trigger = getCartTrigger(e.target);
    if (!trigger) return;

    // immer im gleichen Tab behandeln → Defaults unterbinden
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    // target="_blank" ignorieren
    if (trigger.getAttribute && trigger.getAttribute('target')) {
      trigger.removeAttribute('target');
    }

    // Drawer versuchen zu öffnen, sonst Fallback Navigation im selben Tab
    const opened = openDrawerIfAvailable();
    if (!opened) {
      // im aktuellen Tab navigieren (kein neuer Tab)
      window.__BLOCK_CART_REDIRECT = false; // falls unser Guard aktiv war
      window.location.href = '/cart';
    }
  }, true); // capture!

  // Tastatur (Enter/Space) auf Buttons/Links ebenfalls abfangen
  document.addEventListener('keydown', function (e) {
    if (!(e.key === 'Enter' || e.key === ' ')) return;
    const trigger = getCartTrigger(e.target);
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const opened = openDrawerIfAvailable();
    if (!opened) {
      window.__BLOCK_CART_REDIRECT = false;
      window.location.href = '/cart';
    }
  }, true);

  // Falls der Header dynamisch neu gerendert wird, brauchen wir nichts extra:
  // Wir hängen global (capture) – neue Elemente werden automatisch mit erfasst.
})();
